import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';
import { Observable } from 'rxjs';


export const contentData: Array<any> = [
  // line
  {
    cols: [{
      fieldName: 'msr',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'msd',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'cto',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'hsb',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'sta',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'plc',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'rst',
      width: '50%',
    }, {
      fieldName: 'rpc',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'rcs',
      width: '100%',
    }],
    isNoMarginBottom: true,
  },
  {
    cols: [{
      fieldName: 'rct',
      width: '100%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'ctp',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'ctq',
      width: '50%',
      type: DetailsControlType.Select,
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'ctr',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'cts',
      width: '50%',
      type: DetailsControlType.Select,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'hac',
      width: '50%',
    }, {
      fieldName: 'hts',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'hz1',
      width: '50%',
    }, {
      fieldName: 'naf',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'tmc',
      width: '50%',
    }, {
      fieldName: 'plm',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },

  // line
  {
    cols: [{
      fieldName: 'ltm',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },

  // line
  {
    cols: [{
      fieldName: 'rpq',
      width: '50%',
    }, {
      fieldName: 'whs',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },

  // line
  {
    cols: [{
      fieldName: 'vmi',
      width: '50%',
    }, {
      fieldName: 'ecn',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },

  // line
  {
    cols: [{
      fieldName: 'gct',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'gpv',
      width: '50%',
      type: DetailsControlType.Select,
    }],
    isNoMarginBottom: true,
  },
];
